import { motion } from "framer-motion";
import './works.scss'

const steps = [
    {
        title: "Set the Horizon",
        desc: "Choose your investment path – 5, 10, or 20+ years.",
    },
    {
        title: "Understand Your Risk",
        desc: "Choose your investment path – 5, 10, or 20+ years.",
    },
    {
        title: "Define Your Priorities",
        desc: "Choose your investment path – 5, 10, or 20+ years.",
    },
    {
        title: "Build Your Portfolio",
        desc: "Choose your investment path – 5, 10, or 20+ years.",
    },
];

// Анимации для контейнера и карточек
const gridVariants = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.18,
        },
    },
};

const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

export default function Works() {
    return (
        <div className="works container" id="info">
            <h2 className="works__title">How It Works</h2>
            <motion.div
                className="works__grid"
                variants={gridVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
            >
                {/* 01 */}
                <motion.div className="works__card" variants={cardVariants}>
                    <div className="works__card-number">01/</div>
                    <div className="works__card-title">{steps[0].title}</div>
                    <div className="works__card-desc">{steps[0].desc}</div>
                </motion.div>
                {/* 02 */}
                <motion.div className="works__card" variants={cardVariants}>
                    <div className="works__card-number">02/</div>
                    <div className="works__card-title">{steps[1].title}</div>
                    <div className="works__card-desc">{steps[1].desc}</div>
                </motion.div>

                {/* Пустые для смещения */}
                <div className="works__card works__card--empty"></div>
                <div className="works__card works__card--empty"></div>

                {/* 03 */}
                <motion.div className="works__card" variants={cardVariants}>
                    <div className="works__card-number">03/</div>
                    <div className="works__card-title">{steps[2].title}</div>
                    <div className="works__card-desc">{steps[2].desc}</div>
                </motion.div>
                {/* 04 */}
                <motion.div className="works__card" variants={cardVariants}>
                    <div className="works__card-number">04/</div>
                    <div className="works__card-title">{steps[3].title}</div>
                    <div className="works__card-desc">{steps[3].desc}</div>
                </motion.div>
            </motion.div>
        </div>
    );
}
